import React, {FC, useState} from 'react';
import {View, Pressable, TextInput} from 'react-native';
import Typography from 'design-system/src/Components/Typography/Typography';
import Metrics from 'design-system/src/Theme/Metrics';
import {useTranslation} from 'gatsby-plugin-react-i18next';
import MtnLogo from './MtnLogo';

// UI only for now: the MTN OTP API is not available yet, so "Send OTP" shows a notice.
// Wire requestOtp/submitOtp here once the MTN backend endpoints exist (see VodacomOtpLogin).
const MtnOtpLogin: FC = () => {
  const [msisdn, setMsisdn] = useState('');
  const [error, setError] = useState<string | null>(null);
  const {t} = useTranslation('auth');

  const handleRequestOtp = () => {
    const digits = msisdn.replace(/\D/g, '');
    if (digits.length < 9) {
      setError(t('Please enter a valid MTN phone number'));
      return;
    }
    setError(t('MTN sign in is coming soon.'));
  };

  return (
    <View style={{width: '100%' as any, alignItems: 'center'}}>
      <Typography
        variant="body2"
        color="gray"
        style={{marginBottom: Metrics.verticalScale(8)}}>
        {t('Powered by')}
      </Typography>
      <View style={{marginBottom: Metrics.verticalScale(20)}}>
        <MtnLogo height={90} />
      </View>

      <Typography
        variant="body2"
        color="gray"
        style={{
          textAlign: 'center',
          marginBottom: Metrics.verticalScale(16),
          maxWidth: 320,
        }}>
        {t('Enter your MTN mobile number to receive a one-time PIN')}
      </Typography>

      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
          width: '100%' as any,
          maxWidth: 360,
          backgroundColor: 'rgba(255,255,255,0.08)',
          borderRadius: 8,
          paddingHorizontal: Metrics.horizontalScale(12),
          height: Metrics.verticalScale(48),
          marginBottom: Metrics.verticalScale(12),
        }}>
        <Typography
          variant="body1"
          color="gray"
          style={{marginRight: Metrics.horizontalScale(8)}}>
          +233
        </Typography>
        <TextInput
          value={msisdn}
          onChangeText={setMsisdn}
          placeholder={t('Phone number') as string}
          placeholderTextColor="rgba(255,255,255,0.3)"
          keyboardType="phone-pad"
          maxLength={15}
          style={
            {
              flex: 1,
              color: '#fff',
              fontSize: 16,
              outlineStyle: 'none',
            } as any
          }
          onSubmitEditing={handleRequestOtp}
        />
      </View>

      <Pressable
        onPress={handleRequestOtp}
        disabled={!msisdn.trim()}
        style={{
          backgroundColor: !msisdn.trim() ? 'rgba(255,203,5,0.4)' : '#FFCB05',
          width: '100%' as any,
          maxWidth: 360,
          paddingVertical: Metrics.verticalScale(14),
          borderRadius: 8,
          alignItems: 'center',
        }}>
        <Typography variant="button1" style={{color: '#000'}}>
          {t('Send OTP')}
        </Typography>
      </Pressable>

      {error && (
        <Typography
          variant="body2"
          color="gray"
          style={{marginTop: Metrics.verticalScale(12), textAlign: 'center'}}>
          {error}
        </Typography>
      )}
    </View>
  );
};

export default MtnOtpLogin;
